import { SET_CURRENT_GRID_SIZE } from '../actions';

export default function currentGridSizeReducer(state = '4x4', action) {
    switch(action.type) {
        case SET_CURRENT_GRID_SIZE:
            return action.gridSize;
        default:
            return state;
    }
}